import { apiClient } from './client.ts';
import type { Receipt } from '../types/models.ts';

// ─── Receipts ─────────────────────────────────────────────────────────────────

export async function getReceiptsByHouse(houseId: string): Promise<Receipt[]> {
  return apiClient.get(`houses/${houseId}/receipts`).json<Receipt[]>();
}

export async function generateReceipt(houseId: string, period: string): Promise<Receipt> {
  return apiClient.post(`houses/${houseId}/receipts/generate`, { json: { period } }).json<Receipt>();
}

export async function getReceiptPreview(receiptId: string): Promise<Receipt> {
  return apiClient.get(`receipts/${receiptId}/preview`).json<Receipt>();
}

export function getReceiptPdfUrl(receiptId: string): string {
  return `/api/receipts/${receiptId}/pdf`;
}

export function getReceiptQrUrl(receiptId: string): string {
  return `/api/receipts/${receiptId}/qr`;
}
